import { Theme, createStyles } from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.text.primary,
      display: 'flex',
      flexDirection: 'column',
      gap: `${theme.spacing.unit * 4}px`,
      width: '100%',
      backgroundColor: '#FFFFFF',
    },
  });

export default styles;
